import React, { Component } from 'react';

import Tooltip from './tooltip';

export default class HelpTooltip extends Component {
    render() {
        return (
            <Tooltip
                className={'light help-tooltip' + (this.props.noPadding ? ' no-padding' : '') + (this.props.autoWidth ? ' auto-width' : '')}
                tooltip={this.props.children}
                placement="bottom-start"
            >
                <span className={'help-element over-click-overlay ' + (this.props.className || '') + (this.props.theme ? ` theme-${this.props.theme}` : '')} style={this.props.style}>
                    <i className="help-icon material-icons">help</i>
                </span>
            </Tooltip>
        );
    }
}
